
export default function ContactHero() {
  return (
    <section 
      className="relative py-24 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/e4d478b76a691667f3c9b5b26249130c.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Get in Touch
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Licensed New Jersey car rental company providing professional service since 2021. 
            Our dedicated team is here to assist you with all your rental needs.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white">
            <div className="flex items-center">
              <i className="ri-phone-line text-2xl mr-3"></i>
              <div className="text-left">
                <div className="text-sm text-gray-300">Call Us Now</div>
                <div className="text-xl font-bold">+1 (732) 900-3478</div>
              </div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-gray-400"></div>
            <div className="flex items-center">
              <i className="ri-mail-line text-2xl mr-3"></i>
              <div className="text-left">
                <div className="text-sm text-gray-300">Email Support</div>
                <div className="text-xl font-bold">info@cartogo.co</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
